import actions from './actions'

export default function ContractBudgetInventoryClasssReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_ContractBudgetInventoryClass:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_ContractBudgetInventoryClass:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_ContractBudgetInventoryClass:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_ContractBudgetInventoryClass:
      return {
        ...state,
        editing: { contractBudgetInventoryClassID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_ContractBudgetInventoryClass_RECIEVED ||
      actions.UPDATE_ContractBudgetInventoryClass_RECIEVED ||
      actions.DELETE_ContractBudgetInventoryClass_RECIEVED:
      return {
        ...state,
        editing: { contractBudgetInventoryClassID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
